import { isGradePassed, trim, yearsFromNow, daysFromYearsAgo, filterZeroArrays, getCoursesFromColleges, empty, totalCourseCredits, getTotalLoggedHours, handleize, coursesWithCreditsTotal } from '@/lib/utils'
export default {
  methods: {
    
  },
  computed: {
     // PA Shadowing Hours
     hasPAShadowingHours() {
      if(this.minPAShadowingHours === 0 && this.totalPaShadowingHours === this.minPAShadowingHours) return false
      if(this.totalPaShadowingHours >= this.minPAShadowingHours) return true
    },
    minPAShadowingHours () {
      if (empty(this.savedSchool.pa_shadowing_minimum_hours)) return 0
      return Number(this.savedSchool.pa_shadowing_minimum_hours.split(',').join(''))
    },
    calculatePendingPaShadowingHours () {
      var pendingShadowingHours = parseInt(this.savedSchool.pa_shadowing_minimum_hours) - parseInt(this.totalPaShadowingHours)
      if(pendingShadowingHours < 0) {
        return 0
      } else {
        return pendingShadowingHours
      }

    },
    

  }
}


// WEBPACK FOOTER //
// ./src/mixins/requirementchecks/checkpashadowingmixin.js